import React from "react";
import { Box, Typography } from "@mui/material";
import CustomTableArticle from "./CustomTableArticle";
import CustomOrderLivereur from "./CustomOrderLivereur";
import CustomOrderMap from "./CustomOrderMap";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../hooks";

interface Article {
  LibelleArticle: string;
  QteCommandee: number;
  QteLivree: number;
  QTE_RESTANTE: number;
}

interface ChauffeurCamion {
  FullName: string;
  PhoneNumber: string;
  NumeroCamion: string;
}

interface Camion {
  longitude: string;
  latitude: string;
  data: string;
}

interface OrderDetails {
  NumeroCommande: string;
  NumeroClient: string | null;
  Articles: Article[] | null;
  ChauffeurCamions: ChauffeurCamion[] | null;
  Camions: Camion[] | null;
}

interface CustomDetailOrderProps {
  orderDetails: OrderDetails;
  onFetchOrderDetails: () => void;
}

const CustomDetailOrder: React.FC<CustomDetailOrderProps> = ({
  orderDetails,
  onFetchOrderDetails,
}) => {
  const { t } = useTranslation();
  const { direction } = useAppSelector((state) => state.languageSlice);
  const articles = orderDetails.Articles ?? [];
  const chauffeurCamions = orderDetails.ChauffeurCamions ?? [];
  const camions = orderDetails.Camions ?? [];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: direction === "ltr" ? "row" : "row-reverse",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: "2%",
          }}
        >
          {t("detailCommande.article")}
        </Typography>
        <PublishedWithChangesIcon
          fontSize="medium"
          color="success"
          onClick={onFetchOrderDetails}
          style={{ cursor: "pointer" }}
        />
      </Box>
      {articles.length > 0 ? (
        <CustomTableArticle articles={articles} />
      ) : (
        <Typography variant="body1">
          {t("detailCommande.msgArticle")}
        </Typography>
      )}

      <Typography
        variant="h6"
        sx={{
          marginBottom: "2%",
          marginTop: "2%",
          direction: direction === "ltr" ? "ltr" : "rtl",
        }}
      >
        {t("detailCommande.Livreur")}
      </Typography>
      {chauffeurCamions.length > 0 ? (
        <CustomOrderLivereur chauffeurs={chauffeurCamions} />
      ) : (
        <Typography
          sx={{ direction: direction === "ltr" ? "ltr" : "rtl" }}
          variant="body1"
        >
          {t("detailCommande.msgLivreur")}
        </Typography>
      )}

      <Typography
        variant="h6"
        sx={{
          marginBottom: "2%",
          marginTop: "2%",
          direction: direction === "ltr" ? "ltr" : "rtl",
        }}
      >
        {t("detailCommande.Maps")}
      </Typography>
      {camions.length > 0 ? (
        <CustomOrderMap camions={camions} />
      ) : (
        <Typography
          sx={{ direction: direction === "ltr" ? "ltr" : "rtl" }}
          variant="body1"
        >
          {t("detailCommande.msgMaps")}
        </Typography>
      )}
    </>
  );
};

export default CustomDetailOrder;
